/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInstrumentLinkLimits} from '../api'

 export const useQueryGetInstrumentLinkLimits = createReactQueryHook('getInstrumentLinkLimits', getInstrumentLinkLimits)
